/**
 * .treegrid
 * Bind Tree Grid
 *
 * Create TreeGrid from HTML table
 * In a fresh isntallation requires update to package.json:

    "main": "js/jquery.treegrid.js",
    "files":[
        "js/jquery.treegrid.bootstrap3.js"
    ],
 *
 * @see http://maxazan.github.io/jquery-treegrid/
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

window.treegrid = require('jquery-treegrid');

$(function() {
    "use strict";
    // What selector shall we react to?
    var $selector = '.tree';
    // icons to use
    var $icon_open  = 'fa fa-minus';
    var $icon_close = 'fa fa-plus';
    // Iterate through each element
    $($selector).each(function($index, tree){
        // Make sure this is a jQuery object
        tree = $(tree)
        // Initial State expanded|collapsed
        var $initialState = tree.data('tree-initial-state') || 'collapsed';
        // Initial Root Event
        var $rootEvent = tree.data('tree-root-event') || 'expand';
        // Remember state
        var $saveState = tree.data('tree-save-state') || false;
        // Apply the tree grid
        tree.treegrid({
                'expanderExpandedClass' : $icon_open,
                'expanderCollapsedClass': $icon_close,
                'initialState'          : $initialState,
                'saveState'             : $saveState,
            })
            .treegrid('getRootNodes')
            .treegrid($rootEvent);
    });
});
